import Model from "../Model";

class Syncs extends Model{

    buildUrl ({ param }) {
        return ['/synchro/get_synchro', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Syncs;